import { render, staticRenderFns } from "./WorksAnywhere.vue?vue&type=template&id=30396ddc"
import script from "./WorksAnywhere.vue?vue&type=script&lang=js"
export * from "./WorksAnywhere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default})
